module.exports = "<a class=\"navbar-link icon-link\">\n  <span class=\"icon\">\n    <i class=\"fa fa-lg fa-bell-o\"></i>\n    <span class=\"tag is-success\" *ngIf=\"unread > 0\">{{unread}}</span>\n  </span>\n</a>\n<div class=\"navbar-dropdown is-boxed\">\n  <app-notification-item class=\"navbar-item\" *ngFor=\"let activity of notifications | async\"\n  [reply]=\"activity\" [ngClass]=\"activity.status\">\n  </app-notification-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/activity/notification-list/notification-list.component.html
// module id = ../../../../../src/app/activity/notification-list/notification-list.component.html
// module chunks = 1